import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Derek from "../images/derek.jpg"
import Chris from "../images/chris.jpg"
import LinkedIn from "../images/linkedin.svg"
import Rockhurst from "../images/rockhurst.png"
import Glow from "../images/glow.png"
import Healthcare1 from "../images/healthcare1.jpg"

import "./About.css"

export default function About() {
    return (
        <div>
            <Navbar/>
            {/* HOW IT STARTED SECTION */}
            <div style = {{marginTop: '160px', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between'}}>
                <div style = {{maxWidth: '500px'}}>
                    <p>About</p>
                    <h1>Empowering the Community</h1>
                    <p style = {{marginTop: '20px'}}>At KC Social Nest, we believe that every community 
                        deserves quick and reliable access to the resources they need, 
                        especially in times of crisis. Born out of a commitment to 
                        support the Kansas City area, our platform empowers individuals and 
                        families to discover local aid and services with ease. Whether you're 
                        navigating the aftermath of a natural disaster or simply looking for 
                        assistance, KC Social Nest bridges the gap between you and the help you need.</p>
                </div>
                <div>
                    <img src = {Healthcare1} style = {{width: "40vw", maxWidth: '900px', borderRadius: '24px', minWidth: '300px'}}></img>
                </div>
            </div>

            {/* WHY WE EXIST */}
            <h1 style = {{textAlign: 'center', marginBottom: '50px', marginTop: '100px'}}>Why KC Social Nest Exists</h1>
            <div id = "exists-grid" style = {{display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', rowGap: '20px', maxWidth: '1200px', marginLeft: 'auto', marginRight: 'auto'}}>
                <p style = {{fontFamily: 'Montserrat-Bold'}}>Pain Point</p>
                <p style = {{fontFamily: 'Montserrat-Bold'}}>What People Experience Today</p>
                <p style = {{fontFamily: 'Montserrat-Bold'}}>How We Fix It</p>
                <p>Fragmented info</p>
                <p>Dozens of agency websites, outdated PDFs</p>
                <p>Unified chat interface pulling from one refreshed knowledge base</p>
                <p>Time pressure</p>
                <p>People searching while in crisis</p>
                <p>AI "concierge" triages needs in seconds</p>
                <p>Stigma</p>
                <p>Asking for help can feel intimidating</p>
                <p>Anonymous, judgement-free conversation 24/7</p>

            </div>

            {/* ROCKHURST SECTION */}
            <h1 style = {{textAlign: 'center', marginTop: '100px', marginBottom: '20px'}}>Support</h1>
            <div style = {{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '50px'}}>
                <img src = {Rockhurst} style = {{width: '350px', height: '85px'}}></img>
                <p style = {{width: '40vw', maxWidth: '500px'}}>Thanks to the support of Rockhurst University, 
                    we've been able to expand our vision and bring 
                    this essential tool to life. With KC Social Nest, 
                    we're not just building a platform—we're fostering 
                    resilience, connection, and hope in our community.
                    This project was funded by Andrew Mcneil Universal D.E.I Award/Grant.
                </p>
            </div>

            {/* TEAM SECTION */}
            <h1 style = {{textAlign: 'center', marginTop: '100px'}}>The Team</h1>
            <div style = {{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '20px', gap: '50px', marginBottom: '100px'}}>
            <div className = "team-person">
                    <div className = "image">
                        <img src = {Chris}></img>
                    </div>
                    <p className = "role">Clinical Resource Director</p>
                    <p className = "name">Chris Obersteadt</p>
                    {/* <p className = "desc">Pre-med undergraduate from Rockhurst University, 
                        Chris coined the idea for KC Social Nest and landed the grant from Rockhurst University to
                        make the application possible. Chris has worked lots with the community as an Emergency Medical Technician
                        for KU Health.
                    </p> */}
                </div>
                <div className = "team-person">
                    <div className = "image">
                        <img src = {Derek}></img>
                    </div>
                    <p className = "role">Lead Developer</p>
                    <p className = "name">Derek Nissen</p>
                    {/* <p className = "desc">Computer Science undergraduate from the University of Missouri, 
                        Derek designed and engineered the KC Social Nest application. 
                        Derek grew up in Kansas City, Missouri and has lots of tech experience
                        from undergraduate research and companies including ThermAvant International and Apple.
                    </p> */}
                </div>
            </div>
            <img className = "glow" src = {Glow}></img>
            <Footer/>
        </div>
    )
}